import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const AnonymousMedia = lazyWithSuspense(async () => import('./AnonymousMediaScreen'), {
  loadingState: <LoadingState />,
});
